import { render, staticRenderFns } from "./UserNotificacion.vue?vue&type=template&id=704e586f&"
import script from "./UserNotificacion.vue?vue&type=script&lang=js&"
export * from "./UserNotificacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports